import { useLayoutEffect, useRef } from "react";
import { BaseEdge, EdgeLabelRenderer, getSmoothStepPath } from "@xyflow/react";
import { get } from "lodash";
import PropTypes from "prop-types";
import CanvasIcon from "./CanvasIcon";
import { EDGE_TONES } from "./edge-look";
import { ICON_PATHS } from "./step-look";

const PILL_ICONS = {
  [EDGE_TONES.TIMER]: ICON_PATHS.clock,
  [EDGE_TONES.EVENT]: ICON_PATHS.bolt,
};

const RuleEdge = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  markerEnd,
  data,
}) => {
  const [path, labelX, labelY] = getSmoothStepPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
    borderRadius: 6,
  });
  const pill = get(data, "pill");
  const icon = pill ? PILL_ICONS[pill.tone] : null;
  const labelRef = useRef(null);

  useLayoutEffect(() => {
    if (!labelRef.current) return;
    labelRef.current.style.setProperty("--canvas-edge-x", `${labelX}px`);
    labelRef.current.style.setProperty("--canvas-edge-y", `${labelY}px`);
  }, [labelX, labelY]);

  return (
    <>
      <BaseEdge id={id} path={path} markerEnd={markerEnd} />
      {pill ? (
        <EdgeLabelRenderer>
          <button
            type="button"
            ref={labelRef}
            className={`canvas-edge-pill canvas-edge-pill--${pill.tone} nodrag nopan`}
            onClick={() => get(data, "onOpen", () => {})()}
          >
            {icon ? <CanvasIcon path={icon} size={13} strokeWidth={2} /> : null}
            {pill.rank ? (
              <span className="canvas-edge-pill__rank">{pill.rank}</span>
            ) : null}
            {pill.text}
          </button>
        </EdgeLabelRenderer>
      ) : null}
    </>
  );
};

RuleEdge.propTypes = {
  id: PropTypes.string.isRequired,
  sourceX: PropTypes.number.isRequired,
  sourceY: PropTypes.number.isRequired,
  targetX: PropTypes.number.isRequired,
  targetY: PropTypes.number.isRequired,
  sourcePosition: PropTypes.string,
  targetPosition: PropTypes.string,
  markerEnd: PropTypes.string,
  data: PropTypes.object,
};

RuleEdge.defaultProps = {
  sourcePosition: undefined,
  targetPosition: undefined,
  markerEnd: undefined,
  data: {},
};

export default RuleEdge;
